import { render, staticRenderFns } from "./AssignStaff.vue?vue&type=template&id=3e714bad&scoped=true"
import script from "./AssignStaff.vue?vue&type=script&lang=js"
export * from "./AssignStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e714bad",
  null
  
)

export default component.exports